import React from "react";
import { useTranslation } from "react-i18next";
import { useHighlight } from "../../hooks/useHighlight";

/** Material-UI */
// import Accordion from "@material-ui/core/Accordion";
// import AccordionSummary from "@material-ui/core/AccordionSummary";
// import AccordionDetails from "@material-ui/core/AccordionDetails";
import {
    alpha,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Checkbox,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const AccessibilityTooltip = React.lazy(() => import("../../components/_common/AccessibilityTooltip"));

const BORDERED_LAYOUT = process.env.REACT_APP_BORDERED_LAYOUT
    ? JSON.parse(process.env.REACT_APP_BORDERED_LAYOUT)
    : false;

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        "&:not($AccordionRootExpanded) + &": {
            borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        },
        // borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        boxShadow: "none",
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    AccordionRootExpanded: {
        border: BORDERED_LAYOUT ? "1px solid" : "none",
        borderColor: BORDERED_LAYOUT ? alpha(theme.palette.primary.main, 0.25) : "inherit",
        borderRadius: BORDERED_LAYOUT ? 20 : 0,
        overflow: "hidden",
        margin: "0px!important",
        "& + &": {
            marginTop: "16px!important",
        },
        "& > div:first-child": {
            backgroundColor: alpha(theme.palette.primary.main, 0.025),
        },
    },
    AccordionSummaryRoot: {
        // backgroundColor: alpha(theme.palette.primary.main, 0.0675),
        // borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        marginBottom: -1,
        minHeight: "32px!important",
        "&.$expanded": {
            minHeight: 32,
        },
        "&:focus-visible ": {
            outline: "#000 auto 2px",
            outlineOffset: 0,
        },
        [theme.breakpoints.down("sm")]: {
            padding: 0,
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        // margin: theme.spacing(0, 0),
        // backgroundColor: alpha(theme.palette.primary.main, 0.0675),
    },
    AccordionSummaryTitle: {
        fontSize: "clamp(14px, 2vw, 1.25rem)",
        fontWeight: 600,
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
        },
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: 0,
        },
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.00675),
        padding: theme.spacing(1, 1, 0, 2),
    },
    cardContent: {
        padding: theme.spacing(0, 1, 2, 2),
    },
    cardHeaderTitle: {
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightMedium,
    },
    expanded: {},
    listItemTextPrimary: {
        fontSize: "clamp(14px, 2vw, 1.125rem)",
        textWrap: "pretty",
        fontWeight: 500,
        [theme.breakpoints.down("sm")]: {
            // textWrap:"balance",
        },
    },
    listItemTextSecondary: {
        color: "#000000DE",
        fontSize: "clamp(13px, 2vw, 1.125rem)",
        textWrap: "pretty",
        [theme.breakpoints.down("sm")]: {
            // textWrap:"balance",
        },
    },
    itemTitleLink: {
        color: "#001d77",
        textDecoration: "inherit",
        // fontSize:'1.125rem',
        "&:hover": {
            textDecoration: "underline",
        },
    },
    checkbox: {
        "&:focus-within ": {
            outline: "#000 auto 2px",
            outlineOffset: 2,
        },
    },
    expandIcon: {
        marginRight: -8,
        "&:focus-visible ": {
            outline: "#000 auto 2px",
            outlineOffset: 2,
        },
    },
    focusVisible: {
        backgroundColor: `${alpha(theme.palette.primary.main, 0.025)}!important`,
    },
    systemsList: {
        marginLeft: theme.spacing(8),
        paddingTop: 0,
        [theme.breakpoints.down("sm")]: {
            marginLeft: theme.spacing(0),
        },
    },
    listItemTopLI: {
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            alignItems: "flex-start",
            padding: 4,
        },
    },
    listItemLI: {
        display: "flex",
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0, 1, 0, 3),
        },
    },
    listItemIcon: {
        minWidth: "unset",
    },
}));

const GestorzyAccordion = ({ gestor, data, checked, onChecked, report, search, expanded, onExpand, isMobile }) => {
    const { i18n, t } = useTranslation();
    const { highlight } = useHighlight();
    const classes = useStyles();

    // const [expanded, setExpanded] = useState("");

    // useEffect(()=>{
    //     !!allExpanded && setExpanded("")
    // },[allExpanded])

    const handleChange = (panel) => (event, newExpanded) => {
        if (event.target.hasAttribute("data-preventactions")) return;
        // setExpanded(newExpanded ? panel : false);
        onExpand && onExpand(panel);
    };

    const handleToggle = (event, value) => {
        onChecked(value);
    };

    return (
        <>
            <Accordion
                square
                // expanded={expanded === `obiekt-${gestor.id}`}
                expanded={expanded?.includes(`obiekt-${gestor.id}`)}
                onChange={handleChange(`obiekt-${gestor.id}`)}
                classes={{ root: classes.AccordionRoot, expanded: classes.AccordionRootExpanded }}
                tabIndex={-1}
                component={"li"}
            >
                <AccordionSummary
                    aria-controls={`obiekt-${gestor.id}-content`}
                    id={`obiekt-${gestor.id}-header`}
                    expandIcon={<ExpandMoreIcon fontSize={isMobile ? "small" : "medium"} color={"primary"} />}
                    classes={{
                        root: classes.AccordionSummaryRoot,
                        content: classes.AccordionSummaryContent,
                        expandIcon: classes.expandIcon,
                        focusVisible: classes.focusVisible,
                    }}
                    aria-label={gestor.title}
                    role="row"
                >
                    <ListItem component={"div"} className={classes.listItemTopLI}>
                        {report && (
                            <ListItemIcon className={classes.listItemIcon}>
                                <AccessibilityTooltip
                                    arrow={false}
                                    placement="left"
                                    title={
                                        !!(
                                            checked.filter((c) => c.gestor_id === gestor.id).length &&
                                            checked.filter((c) => c.gestor_id === gestor.id).length === data.length
                                        )
                                            ? t(`Usuń z raportu`)
                                            : t(`Dodaj do raportu`)
                                    }
                                >
                                    <Checkbox
                                        edge="start"
                                        checked={
                                            !!(
                                                checked.filter((c) => c.gestor_id === gestor.id).length &&
                                                checked.filter((c) => c.gestor_id === gestor.id).length === data.length
                                            )
                                        }
                                        disableRipple
                                        inputProps={{
                                            "data-preventactions": true,
                                            "aria-labelledby": `gestor-${gestor.id}`,
                                        }}
                                        indeterminate={
                                            !!(
                                                checked.filter((c) => c.gestor_id === gestor.id).length &&
                                                checked.filter((c) => c.gestor_id === gestor.id).length < data.length
                                            )
                                        }
                                        color={"primary"}
                                        onChange={(event) => handleToggle(event, data)}
                                        className={classes.checkbox}
                                        tabIndex={0}
                                        size={isMobile ? "small" : "medium"}
                                    />
                                </AccessibilityTooltip>
                            </ListItemIcon>
                        )}
                        <ListItemText
                            id={`gestor-${gestor.id}`}
                            primary={
                                <Typography className={classes.AccordionSummaryTitle}>
                                    {/* {gestor.title} */}
                                    {highlight({ text: gestor.title, search, classes })}
                                    &nbsp;<small>({data.length})</small>
                                </Typography>
                            }
                        />
                    </ListItem>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.AccordionDetailsRoot }}>
                    <List className={classes.systemsList}>
                        {data.map((item, key) => {
                            return (
                                <ListItem
                                    dense={true}
                                    className={classes.listItemLI}
                                    classes={{ selected: classes.listItemSelected }}
                                    key={key}
                                    id={`item-${item.id_systemu}`}
                                >
                                    {report && (
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <AccessibilityTooltip
                                                arrow={false}
                                                placement="left"
                                                title={
                                                    checked.find((c) => c.id_systemu === item.id_systemu)
                                                        ? t(`Usuń z rapotu`)
                                                        : t(`Dodaj do raportu`)
                                                }
                                            >
                                                <Checkbox
                                                    edge="start"
                                                    checked={!!checked.find((c) => c.id_systemu === item.id_systemu)}
                                                    disableRipple
                                                    inputProps={{ "aria-labelledby": item.id_systemu }}
                                                    color={"primary"}
                                                    onChange={(event) => handleToggle(event, item)}
                                                    className={classes.checkbox}
                                                    size={isMobile ? "small" : "medium"}
                                                />
                                            </AccessibilityTooltip>
                                        </ListItemIcon>
                                    )}
                                    <ListItemText
                                        id={item.id_systemu}
                                        primary={
                                            <a
                                                // href={`/${i18n.language}/rsisystemy/${item.id_systemu}?from=rsigestorzy`}
                                                href={`/${i18n.language}/rsisystemy/${item.id_systemu}?from=rsigestorzy`}
                                                rel="noopener noreferrer"
                                                className={classes.itemTitleLink}
                                            >
                                                {item.nazwa_systemu}
                                            </a>
                                        }
                                        secondary={`${item.nazwa_systemu_skr ? item.nazwa_systemu_skr + ", " : ""} ${
                                            item.gestor
                                        }`}
                                        classes={{
                                            primary: classes.listItemTextPrimary,
                                            secondary: classes.listItemTextSecondary,
                                        }}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default GestorzyAccordion;
